import React, { useState, useEffect } from "react";
import { Switch, Route, useLocation, Redirect } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import axios from "axios";
import styled from "styled-components";

// Google Analytics
import ReactGA from "react-ga";
import RouteChangeTracker from "./components/public/analytics/RouteChangeTracker";
// APIs
import { recordUserActivityApi } from "./utility/api/apiList";
// actions
import constantType from "./redux/actions/constant/constantType";
import userMessageType from "./redux/actions/userMessage/userMessageType";
import { closeAlert } from "./redux/actions/alert/alertActions";
// components
import PublicRoute from "./router/public/PublicRoute";
import PrivateRoute from "./router/private/privateRoute";

import ErrorPage from "./components/public/error";
import ErrorBoundary from "./components/public/error/errorBoundary";

import NavbarContainer from "./containers/navbar";
import FooterComponent from "./components/public/footer";

import ModalComponent from "./components/public/modal";
import AlertComponent from "./components/public/alert";

import HomePageContainer from "./containers/home";
import SimPageContainer from "./containers/sims";
import AboutUsPageComponent from "./components/public/aboutUs";
import ContactPageComponent from "./components/public/contact";
import PolicyPageComponent from "./components/public/policies";
import PrivacyPageComponent from "./components/public/privacy";
import FAQPageComponent from "./components/public/FAQ";

import Authentication from "./containers/authentication";
import forgetPassPage from "./containers/forgetPass";

// Single Sim
import SingleSimPageContainer from "./containers/singleSim";

//purchase
import PurchasePageComponent from "./containers/purchase/purchase";
import CartContainer from "./containers/purchase/cart";
import CompanyDetailPageContainer from "./containers/purchase/companyDetail";
import PaymentPageContainer from "./containers/purchase/payment";
import GroupPurchasePageContainer from "./containers/purchase/groupPurchase";
import PurchaseSubscriptionCodeContainer from "./containers/purchase/purchaseSubscriptionCode";
import PersonalPurchasePageContainer from "./containers/purchase/personalPurchase";

import SearchContainer from "./containers/search";

//user
import ProfileRouter from "./routes/profile";
import UserFinancialFactorContianer from "./containers/profile/financial/factor";

import singleSimReport from "./containers/singleSimReport";
//login
import loginByToken from "./containers/loginByToken";

//routes
import * as ROUTES from "./routes";
// style
import "./style/base/custom.scss";
import userType from "./redux/actions/user/userType";

import { NavbarLogoImg } from "./components/public/navbar/styledNavbars";
import { Link } from "react-router-dom";
import { Navbar } from "react-bootstrap";
import logoSticky from "./image/logo6.svg";

export default function App() {
  // Google Analytics code
  const TRACKING_ID = "UA-196304994-1";
  ReactGA.initialize(TRACKING_ID);

  const [hideHeader, setHideHeader] = useState(false);
  const user = useSelector((state) => state.userDetail);
  const loginDetail = useSelector((state) => state.loginDetail);
  const constantsDetail = useSelector((state) => state.constantsDetail);
  const dispatch = useDispatch();
  const alertState = useSelector((state) => state.alert);

  if (user.isLogin) {
    axios.defaults.headers["Authorization"] = `Bearer ${user.userToken}`;
  }else{
    try{
      delete axios.defaults.headers["Authorization"];
    }catch(e){}
  }
  axios.interceptors.response.use(
    response => response,
    error => {
      if (error.response && error.response.status == 401 && user.isLogin) {
          dispatch({ type: userType.SET_LOGOUT_USER, refresh:user.userRefreshToken });
      }
      return Promise.reject(error);
    }
  );
  const location = useLocation();

  useEffect(() => {
    const expiration = process.env.REACT_APP_EXPIRATION_DATE_CONSTANT;
    let timestamp = new Date().getTime();
    const dayInMs = 86400000; //24 hours
    var expirationDate = dayInMs * expiration + timestamp;

    if (constantsDetail.constants.length == 0 || constantsDetail?.constants == null) {
      dispatch({
        type: constantType.START_FETCHING_CONSTANT,
        expirationDate: expirationDate,
      });
    } else {
      if (constantsDetail.expirationDate < timestamp) {
        dispatch({
          type: constantType.START_FETCHING_CONSTANT,
          expirationDate: expirationDate,
        });
      } else {
      }
    }

    if (
      location.pathname.includes("sim-report-activity") ||
      location.pathname.includes("factor-detail") ||
      location.pathname.includes("login-by-token")
    ) {
      setHideHeader(true);
    } else {
      setHideHeader(false);
    }

    let qString = new URLSearchParams(window.location.search);
    if (
      qString.get("view-port") == "iframe" ||
      window.location !== window.parent.location
    ) {
      setHideHeader(true);
    }
  }, [location]);

  useEffect(() => {
    // if (user.isLogin && loginDetail.loading==false) {
    // }
    if (user.isLogin && loginDetail.loading == false) {
      // axios.defaults.headers["Authorization"] = `Token ${user.userToken}`;

      axios.post(recordUserActivityApi);
      setInterval(() => {
        axios.post(recordUserActivityApi);
      }, 200000);
      if (window.location == window.parent.location) {
        dispatch({
          type: userMessageType.UPDATE_COUNT_UNREAD_MESSAGE,
        });
        setInterval(() => {
          dispatch({
            type: userMessageType.UPDATE_COUNT_UNREAD_MESSAGE,
          });
        }, 120000);
      }
    }
  }, []);

  window.addEventListener("goftino_ready", function () {
    if (user.isLogin) {
      window.Goftino.setUser({
        email: `${user.userDetail[0].email}`,
        name: `${user.userDetail[0].first_name} ${user.userDetail[0].last_name}`,
        about: `${user.userRole}`,
        phone: `${user.userDetail[0].username}`,
      });
    } else {
      return;
    }
  });

  const checkUserRoleFromURL = () => {
    switch (true) {
      case location.pathname.includes("student"):
        return "student";
      case location.pathname.includes("teacher"):
        return "teacher";
      default:
        return;
    }
  };

  return (
    <ErrorBoundary>
      {hideHeader ? <Navbar.Brand className="ps-4 py-0" style={{'margin-top': '-55px',"position": 'absolute'}}>
          <Link to="/sims">
            <NavbarLogoImg
              src={logoSticky}
              alt="azeto-main-logo"
              width="140"
              height="36"
            />
          </Link>
        </Navbar.Brand> : <Route component={NavbarContainer} />}
      {alertState.isModal ? (
        <ModalComponent
          show={alertState.isModal}
          onHide={() => dispatch(closeAlert())}
        >
          {alertState.content}
        </ModalComponent>
      ) : (
        <AlertComponent show={alertState.show}>{alertState.content}</AlertComponent>
      )}
      <StyledMain>
        <Switch>
          <PublicRoute restricted={false} component={HomePageContainer} path="/" exact />
          <Redirect from="/home" to="/" />
          <PublicRoute
            restricted={false}
            component={AboutUsPageComponent}
            path={ROUTES.ROUTE_ABOUT_US}
            exact
          />
          <PublicRoute
            restricted={false}
            component={ContactPageComponent}
            path={ROUTES.ROUTE_CONTACT}
            exact
          />
          <PublicRoute
            restricted={false}
            component={PolicyPageComponent}
            path={ROUTES.ROUTE_POLICIES}
            exact
          />
          <PublicRoute
            restricted={false}
            component={PrivacyPageComponent}
            path={ROUTES.ROUTE_PRIVACY}
            exact
          />
          <PublicRoute
            restricted={false}
            component={FAQPageComponent}
            path={ROUTES.ROUTE_FAQ}
            exact
          />
          {/* sims */}
          <PublicRoute
            restricted={false}
            component={SimPageContainer}
            path={ROUTES.ROUTE_SIMS}
            exact
          />
          <PublicRoute
            restricted={false}
            component={SingleSimPageContainer}
            path={ROUTES.ROUTE_SIM_ID}
            exact
          />
          <PublicRoute
            restricted={false}
            component={singleSimReport}
            path={ROUTES.ROUTE_SIM_REPORT_ACTIVITY_ID}
            exact
          />
          {/* login and register */}
          <PublicRoute
            restricted={false}
            component={loginByToken}
            path={ROUTES.ROUTE_LOGIN_BY_TOKEN}
            exact
          />
          <PublicRoute
            restricted={true}
            component={Authentication}
            path={ROUTES.ROUTE_AUTHENTICATION}
            exact
          />

          <PublicRoute
            restricted={false}
            component={forgetPassPage}
            path={ROUTES.ROUTE_FORGET_PASSWORD}
            exact
          />
          {/* purchase */}
          <PublicRoute
            restricted={false}
            component={PurchasePageComponent}
            path={ROUTES.ROUTE_PURCHASE}
            exact
          />
          {/* <PublicRoute restricted={false}  /> */}
          <PublicRoute
            restricted={false}
            component={GroupPurchasePageContainer}
            path={ROUTES.ROUTE_GROUP_PURCHASE}
            exact
          />
          <PublicRoute
            restricted={false}
            component={PurchaseSubscriptionCodeContainer}
            path={ROUTES.ROUTE_PURCHASE_SUBSCRIPTION_CODE}
            exact
          />
          <PublicRoute
            restricted={false}
            component={CartContainer}
            path={ROUTES.ROUTE_CART}
            exact
          />
          <PublicRoute
            restricted={false}
            component={CompanyDetailPageContainer}
            path={ROUTES.ROUTE_COMPANY_DETAIL}
            exact
          />
          <PublicRoute
            restricted={false}
            component={PersonalPurchasePageContainer}
            path={ROUTES.ROUTE_PERSONAL_PURCHASE_PAGE}
            exact
          />
          <PublicRoute
            restricted={false}
            component={PaymentPageContainer}
            path={ROUTES.ROUTE_PAYMENT}
            exact
          />

          {/* search */}
          <PublicRoute
            restricted={false}
            component={SearchContainer}
            // component={searchPage}
            path={ROUTES.ROUTE_SEARCH}
            exact
          />
          {/* user */}
          <PrivateRoute
            noRole={false}
            userRole={user.userRole}
            component={UserFinancialFactorContianer}
            path={`${
              user.userRole === "student"
                ? ROUTES.ROUTE_STUDENT
                : ROUTES.ROUTE_TEACHER
            }/${ROUTES.ROUTE_FINANCIAL_FACTOR_DETAIL_ID}`}
            exact
          />
          {/* profile */}
          <PrivateRoute
            noRole={false}
            component={ProfileRouter}
            userRole={checkUserRoleFromURL()}
            path={`${
              user.userRole === "student"
                ? ROUTES.ROUTE_STUDENT
                : ROUTES.ROUTE_TEACHER
            }`}
          />

          <Route path={ROUTES.ROUTE_ERROR_PAGE} exact component={ErrorPage} />
        </Switch>
      </StyledMain>
      {/* <PublicRoute/> */}
      {/* <Login_registerRoute /> */}
      {hideHeader ? <></> : <Route component={FooterComponent} />}
      <RouteChangeTracker />
    </ErrorBoundary>
  );
}

const StyledMain = styled.main`
  background-color: var(--bg-color);
  /* Add margin top due sticky navbar */
  margin-top: 80px;
  @media screen and (max-width: 758px) {
    margin-top: 60px;
  }
`;
